import "./App.css";

import Message from "./components/Message";
import {
  onAuthStateChanged,
  signInWithPopup,
  getAuth,
  GoogleAuthProvider,
  signOut,
} from "firebase/auth";
import { useEffect, useRef, useState } from "react";
import {
  getFirestore,
  addDoc,
  collection,
  serverTimestamp,
  onSnapshot,
  query,
  orderBy,
} from "firebase/firestore";
import { app } from "./firebase";
import { VStack, Button } from "@chakra-ui/react";
const auth = getAuth(app);
const db = getFirestore(app);

const provider = new GoogleAuthProvider();
function App() {
  const [user, setUser] = useState(false);
  const [message, setMessage] = useState("");
  const [messages, setMessages] = useState([]);

  const divForScroll = useRef(null);
  const q = query(collection(db, "Messages"), orderBy("createdAt", "asc"));
  const loginHandle = () => {
    signInWithPopup(auth, provider);
  };
  useEffect(() => {
    const unsubcribe = onAuthStateChanged(auth, (data) => {
      setUser(data);
    });
    onSnapshot(q, (snap) => {
      setMessages(
        snap.docs.map((item) => {
          const id = item.id;
          return { id, ...item.data() };
        })
      );
    });
    return () => {
      unsubcribe();
    };
  }, []);

  const logoutHandler = () => {
    signOut(auth);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "Messages"), {
        text: message,
        uid: user.uid,
        url: user.photoURL,
        createdAt: serverTimestamp(),
      });

      setMessage("");
      divForScroll.current.scrollIntoView();
    } catch (err) {
      alert(err);
    }
  };
  return (
    <>
      {user ? (
        <div className="chat-container">
          <div className="chat-header">
            <h1>Chat App</h1>
            <button
              w={"full"}
              bg={"red"}
              id="logoutBtn"
              onClick={logoutHandler}
            >
              Logout
            </button>
          </div>

          <VStack
            h={"full"}
            w={"full"}
            paddingX={"3"}
            paddingY={"4"}
            overflowY={"auto"}
            css={{
              "&::-webkit-scroll-bar": {
                display: "none",
              },
            }}
          >
            {messages.map((item) => {
              return (
                <Message
                  key={item.id}
                  user={item.uid === user.uid ? "me" : "other"}
                  text={item.text}
                  url={item.url}
                />
              );
            })}
            <div ref={divForScroll}></div>
          </VStack>
          <div className="chat-input">
            <input
              type="text"
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Type your message..."
            />
            <button id="sendBtn" onClick={submitHandler}>
              Send
            </button>
          </div>
        </div>
      ) : (
        <VStack justifyContent={"center"} h={"100vh"} bg={"white"}>
          <Button
            style={{
              backgroud: "white",
              color: "#000",
              boxShadow: "2px 2px 2px 2px",
            }}
            onClick={loginHandle}
          >
            <img
              width={30}
              height={40}
              style={{marginRight:"20px"}}
              src="https://cdn.pixabay.com/photo/2021/05/24/09/15/google-logo-6278331_640.png"
              alt=""
            />
            Continue in Google
          </Button>
        </VStack>
      )}
    </>
  );
}

export default App;
